import Swiper from 'swiper';
import {A11y, Navigation, Pagination, Autoplay} from 'swiper/modules';

window.Swiper = Swiper;



export function initSwiper() {
    // Общие параметры для всех слайдеров
    const commonOptions = {

    };

    // Инициализация всех слайдеров с базовыми параметрами
    const sliders = document.querySelectorAll('.swiper-container');

    sliders.forEach((slider) => {
        // Проверка типа элемента и приведение к HTMLElement
        if (slider instanceof HTMLElement) {
            // Уникальные параметры для каждого слайдера через класс
            let uniqueOptions = { ...commonOptions };

            if (slider.classList.contains('swiper-reviews')) {
                // Настройки именно для advice
                uniqueOptions = {
                    ...uniqueOptions,
                    modules: [Navigation, A11y],
                    spaceBetween: 8,
                    a11y: true,
                    navigation: {
                        nextEl: '.reviews-head-left .swiper-arrow-next',
                        prevEl: '.reviews-head-left .swiper-arrow-prev',
                    },
                    breakpoints: {
                        320: {
                            slidesPerView: 1,
                        },
                        600: {
                            slidesPerView: 2,
                        },
                        991: {
                            slidesPerView: 3,
                        }
                    }
                };
            }

            // Инициализируем слайдер с уникальными параметрами
            new Swiper(slider, uniqueOptions);
        }
    });
}

